var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.message
      ? _c(
          "div",
          {
            staticClass: "notification is-light",
            class: _vm.messageType,
            attrs: { "data-test": "form-message" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _vm.active
      ? _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "required-field",
              {
                attrs: {
                  error: _vm.$v.firstname.$error,
                  required: _vm.$v.firstname.required,
                  label: "First name",
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.$v.firstname.$model,
                      expression: "$v.firstname.$model",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "input",
                  class: { "is-danger": _vm.$v.firstname.$error },
                  attrs: { type: "text", "data-test": "firstname" },
                  domProps: { value: _vm.$v.firstname.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.$v.firstname,
                        "$model",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]
            ),
            _c(
              "required-field",
              {
                attrs: {
                  error: _vm.$v.lastname.$error,
                  required: _vm.$v.lastname.required,
                  label: "Surname",
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.$v.lastname.$model,
                      expression: "$v.lastname.$model",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "input",
                  class: { "is-danger": _vm.$v.lastname.$error },
                  attrs: { type: "text", "data-test": "lastname" },
                  domProps: { value: _vm.$v.lastname.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.$v.lastname,
                        "$model",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]
            ),
            _c(
              "required-field",
              {
                attrs: {
                  error: _vm.$v.password.$error,
                  required: _vm.$v.password.required,
                  label: "Password",
                },
              },
              [
                _c("p", { staticClass: "mb-4" }, [
                  _vm._v(
                    " Choose a password with eight characters or more. For a strong password, use a combination of lowercase and uppercase letters, numbers and special characters "
                  ),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.$v.password.$model,
                      expression: "$v.password.$model",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "input",
                  class: { "is-danger": _vm.$v.password.$error },
                  attrs: { type: "password", "data-test": "password" },
                  domProps: { value: _vm.$v.password.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.$v.password,
                        "$model",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                !_vm.$v.password.minLength
                  ? _c(
                      "p",
                      {
                        staticClass: "help is-danger",
                        attrs: { "data-test": "password-validation" },
                      },
                      [
                        _vm._v(
                          " Password must have at least " +
                            _vm._s(_vm.$v.password.$params.minLength.min) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _c(
              "required-field",
              {
                attrs: {
                  error: _vm.$v.repeatPassword.$error,
                  required: _vm.$v.repeatPassword.required,
                  label: "Confirm password",
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.$v.repeatPassword.$model,
                      expression: "$v.repeatPassword.$model",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "input",
                  class: { "is-danger": _vm.$v.repeatPassword.$error },
                  attrs: { type: "password", "data-test": "confirm_password" },
                  domProps: { value: _vm.$v.repeatPassword.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.$v.repeatPassword,
                        "$model",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                !_vm.$v.repeatPassword.sameAsPassword
                  ? _c(
                      "p",
                      {
                        staticClass: "help is-danger",
                        attrs: { "data-test": "confirmpassword-validation" },
                      },
                      [_vm._v(" Passwords must be identical. ")]
                    )
                  : _vm._e(),
              ]
            ),
            _c("div", { staticClass: "buttons" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary gtm-save",
                  class: { "is-loading": _vm.fetching },
                  attrs: { disabled: !_vm.isValid, "data-test": "submit" },
                },
                [_vm._v(" Save password ")]
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }